import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { uploadConsultees } from '../methods';
import { UploadConsulteesResponse } from '../types';

export const useUploadConsultees = (): UseMutationResult<
  UploadConsulteesResponse,
  unknown,
  FormData
> => {
  return useMutation(uploadConsultees);
};
